/* ===========================================================================
   Rechtliche Seiten: Inhaltsverzeichnis
   ---------------------------------------------------------------------------
   Die Richtlinientexte (v. a. die Datenschutzerklärung) sind sehr lang. Aus
   den vorhandenen Überschriften wird daher ein Sprungmenü erzeugt – rein als
   Progressive Enhancement, der Text bleibt ohne JavaScript vollständig lesbar.
   =========================================================================== */
(function () {
  'use strict';

  var MIN_HEADINGS = 3;

  var body = document.querySelector('.shopify-policy__body');
  if (!body) return;

  function trimLeadingSpace(element) {
    var node = element.firstChild;
    while (node && node.nodeType === 3 && !node.nodeValue.trim()) {
      element.removeChild(node);
      node = element.firstChild;
    }
    if (!node) return;
    var target = node.nodeType === 3 ? node : node.firstChild;
    if (target && target.nodeType === 3) {
      target.nodeValue = target.nodeValue.replace(/^[\s\u00a0]+/, '');
    }
  }

  // Leerabsätze (meist nur ein geschütztes Leerzeichen) ausblenden.
  Array.prototype.forEach.call(body.querySelectorAll('p'), function (paragraph) {
    if (!paragraph.textContent.trim() && !paragraph.querySelector('img, a, br')) {
      paragraph.classList.add('policy-spacer');
    }
  });

  // Die AGB gliedern nicht mit Überschriften, sondern mit nummerierten,
  // fett gesetzten Einzelzeilen ("1. Geltungsbereich"). Diese werden als
  // Zwischenüberschriften ausgezeichnet – Wortlaut und Reihenfolge bleiben
  // unverändert, lediglich die eingerückten Leerzeichen entfallen.
  Array.prototype.forEach.call(body.querySelectorAll('p'), function (paragraph) {
    if (!paragraph.querySelector('strong, b')) return;

    var text = paragraph.textContent.replace(/[\s\u00a0]+/g, ' ').trim();
    // Nur einstellige/zweistellige Gliederungspunkte: "1. Titel", nicht "1.1 Satz".
    if (!/^\d{1,2}[.)]\s+\S/.test(text) || text.length > 80) return;

    trimLeadingSpace(paragraph);
    paragraph.classList.add('policy-heading');
  });

  var selector = 'h2, h3, h4, .policy-heading';
  var headings = Array.prototype.slice.call(body.querySelectorAll(selector));
  // Überschriften ohne Textinhalt (kommen in den Richtlinien vor) ignorieren.
  headings = headings.filter(function (heading) {
    return heading.textContent.trim().length > 0;
  });

  var topLevel = headings.filter(function (heading) {
    return heading.tagName === 'H2';
  });
  // Manche Richtlinien gliedern nur mit H3 bzw. fetten Zeilen – dann bilden
  // diese die erste Ebene.
  if (topLevel.length < MIN_HEADINGS) {
    headings = headings.filter(function (heading) {
      return heading.tagName !== 'H2';
    });
  }

  if (headings.length < MIN_HEADINGS) return;

  // Eingerückte Leerzeichen vor Überschriften entfernen (z. B. in den AGB).
  headings.forEach(trimLeadingSpace);

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  var used = {};
  var items = headings.map(function (heading, index) {
    if (!heading.id) {
      var base = slugify(heading.textContent) || 'abschnitt';
      var id = base;
      var suffix = index;
      while (used[id] || document.getElementById(id)) {
        id = base + '-' + suffix;
        suffix += 1;
      }
      used[id] = true;
      heading.id = id;
    }
    return heading;
  });

  var details = document.createElement('details');
  details.className = 'policy-toc';
  if (window.matchMedia('(min-width: 768px)').matches) {
    details.open = true;
  }

  var summary = document.createElement('summary');
  summary.className = 'policy-toc__summary';
  summary.innerHTML =
    'Auf dieser Seite' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M6 9l6 6 6-6"/></svg>';
  details.appendChild(summary);

  var list = document.createElement('ul');
  list.className = 'policy-toc__list';

  var links = items.map(function (heading) {
    var item = document.createElement('li');
    item.className =
      'policy-toc__item' + (heading.tagName === 'H3' ? ' policy-toc__item--sub' : '');

    var link = document.createElement('a');
    link.className = 'policy-toc__link';
    link.href = '#' + heading.id;
    link.textContent = heading.textContent.trim();

    item.appendChild(link);
    list.appendChild(item);
    return link;
  });

  details.appendChild(list);

  var nav = document.createElement('nav');
  nav.setAttribute('aria-label', 'Inhalt dieser Seite');
  nav.appendChild(details);
  body.insertBefore(nav, body.firstChild);

  // Aktiven Abschnitt markieren
  if (!('IntersectionObserver' in window)) return;

  var visible = [];
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var index = visible.indexOf(entry.target);
        if (entry.isIntersecting && index === -1) {
          visible.push(entry.target);
        } else if (!entry.isIntersecting && index !== -1) {
          visible.splice(index, 1);
        }
      });

      if (!visible.length) return;

      var current = visible.reduce(function (first, heading) {
        return heading.offsetTop < first.offsetTop ? heading : first;
      });

      links.forEach(function (link) {
        if (link.hash === '#' + current.id) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    },
    { rootMargin: '-200px 0px -60% 0px' }
  );

  items.forEach(function (heading) {
    observer.observe(heading);
  });
})();
